// @flow

import NewsApi from "apis/newsApi";
import type { NewsDetails } from "apis/models/newsDetails";
import type { NewsFile } from "apis/models/newsFile";
import ACTION_TYPES from "./actionTypes";
import type {
  StartLoadingAction,
  StopLoadingAction,
  SetNewsActionFunc,
  GetNewsDetailsSuccessAction,
  GetNewsDetailsFailedAction
} from "./types";

const startLoading = (): StartLoadingAction => ({
  type: ACTION_TYPES.START_LOADING
});

const stopLoading = (): StopLoadingAction => ({
  type: ACTION_TYPES.STOP_LOADING
});

export const setNewsSuccess = (newsId: number) => ({
  type: ACTION_TYPES.SET_NEWS_DETAILS_SUCCESS,
  selectedNews: newsId
});

const getNewsDetailsSuccess = (
  newsDetailsData: NewsDetails,
  newsFileData: NewsFile
): GetNewsDetailsSuccessAction => ({
  type: ACTION_TYPES.GET_NEWS_DETAILS_SUCCESS,
  newsDetails: newsDetailsData,
  newsFile: newsFileData
});

const getNewsDetailsFailed = (errors: string): GetNewsDetailsFailedAction => ({
  type: ACTION_TYPES.GET_NEWS_DETAILS_FAILED,
  errors
});

export const setNews: SetNewsActionFunc = newsId => async dispatch => {
  dispatch(startLoading());
  dispatch(getNewsDetailsSuccess([], []));
  if (!newsId) {
    dispatch(setNewsSuccess(0));
    dispatch(getNewsDetailsSuccess([], []));
    dispatch(stopLoading());
  } else {
    dispatch(setNewsSuccess(newsId));

    // E.LJ.18.12 try to fix data types
    // $FlowFixMe
    const newsDetails = await NewsApi.getNewsDetails(newsId)
      .then(({ data }) => {
        return data;
      })
      .catch(errors => {
        if (errors && errors.message) {
          dispatch(getNewsDetailsFailed(errors.message));
        }
      });

    let newsFiles = [];

    if (newsDetails !== undefined && newsDetails[0].numberAttachedFiles > 0) {
      newsFiles = await NewsApi.getNewsFiles(newsId)
        .then(({ data }) => {
          return data;
        })
        .catch(errors => {
          if (errors && errors.message) {
            dispatch(getNewsDetailsFailed(errors.message));
          }
        });
    }

    dispatch(getNewsDetailsSuccess(newsDetails, newsFiles));
    dispatch(stopLoading());
  }
};

export default setNews;
